export const UnitsTranslations = {
  en: {
    units: {
      Imperial: {
        weight: "Tons",
        temperature: "°F",
        length: "ft",
      },
      SI: {
        // La capacidad va en toneladas en los dos sistemas: el backend la siembra asi
        // (`capacity` → `Tons` en Imperial y en SI) y `UnitLocator` no la convierte.
        weight: "Tons",
        temperature: "°C",
        length: "Meters",
      },
    },
  },
  es: {
    units: {
      Imperial: {
        weight: "Toneladas",
        temperature: "°F",
        length: "Pies",
      },
      SI: {
        weight: "Toneladas",
        temperature: "°C",
        length: "Metros",
      },
    },
  },
};
